import { useTransition } from '@react-spring/web';

const from = {
  left: 'translateX(-110%)',
  right: 'translateX(110%)'
};

export function useSlide<T>(item: T, side: 'left' | 'right') {
  return useTransition(item, {
    from: { transform: from[side], opacity: 0 },
    enter: { transform: 'translateX(0%)', opacity: 1 },
    leave: { transform: from[side], opacity: 0 },
    config: {
      tension: 170,
      friction: 26,
      duration: 320
    }
  });
}
